import { service } from '../axios';
export function getOrganizationTree(params) {
    return service({
        url: '/organization/tree',
        method: 'get',
        params
    });
}
export function getLabTree(params) {
    return service({
        url: '/organization/labTree',
        method: 'get',
        params
    });
}
export function saveOrganization(data) {
    return service({ url: '/organization/save', method: 'post', data });
}
export function deleteOrganization(data) {
    return service({ url: '/organization/delete', method: 'Delete', data });
}
export function getApproveRoleList(orgId) {
    return service({
        url: `/organization/approve-role/list/${orgId}`,
        method: 'get'
    });
}
export function getApproveUsersByOrgId(orgId) {
    return service({
        url: `/organization/approve-role/getApproveUsersByOrgId/${orgId}`,
        method: 'get'
    });
}
export function getRoleDetailWithUsers(approveRoleId) {
    return service({
        url: `/organization/approve-role/detail/${approveRoleId}`,
        method: 'get'
    });
}
// 保存审批角色及其用户关联（新增/更新角色+用户列表）
export function saveRoleAndUsers(data) {
    return service({
        url: `/organization/approve-role/save-with-users`,
        method: 'post',
        data
    });
}
// 删除审批角色（及其关联用户）
export function deleteApproveRole(approveRoleId) {
    return service({
        url: `/organization/approve-role/delete/${approveRoleId}`,
        method: 'delete'
    });
}
